import AssignForm from "./AssignForm";
import EditForm from "./EditForm";
import PayoutForm from "./PayoutForm";
import TransferForm from "./TransferForm";

function TimeOffForm({ mode, ...props }) {
	switch (mode) {
		case "edit": {
			return <EditForm {...props} />;
		}
		case "transfer": {
			return <TransferForm {...props} />;
		}
		case "payout":
		case "payout-all": {
			return <PayoutForm mode={mode} {...props} />;
		}
		case "create":
		case "clone":
		default: {
			return <AssignForm mode={mode} {...props} />;
		}
	}
}

export default TimeOffForm;
